require('./dist/skulpt.min.js');
require('./dist/skulpt-stdlib.js');

module.exports = Sk;
